import NProgress from "nprogress";

export { onPageTransitionEnd };

async function onPageTransitionEnd() {
  NProgress.done();
}